<template>
  <BaseLinkButton
    :data-testid="dataTestId"
    :class="sizeClass"
    class="tw:font-bold tw:border tw:bg-black tw:border-black tw:text-white tw:text-wrap tw:flex tw:items-center tw:text-base tw:rounded-lg tw:line-height-260 tw:hover:border-black tw:hover:bg-white tw:hover:text-black tw:hover:no-underline"
    v-bind="$attrs"
  >
    <slot />
  </BaseLinkButton>
</template>

<script setup>
import { computed } from 'vue'
import BaseLinkButton from './BaseLinkButton.vue'

const props = defineProps({
  dataTestId: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: 'big',
  },
})

const sizeClass = computed(() => {
  if (props.size === 'small') return 'tw:px-3 tw:py-0.5 tw:text-xs tw:rounded line-height-150'
  if (props.size === 'medium') return 'box-size-36 tw:px-4 tw:py-2 tw:text-sm tw:rounded-lg line-height-180'
  else return 'box-size-44 tw:px-6 tw:py-2 tw:text-base tw:rounded-lg line-height-260'
})
</script>
<style scoped>
@media (hover: hover) and (pointer: fine) {
  button:hover {
    background-color: var(--tw-color-gray-700);
    border-color: var(--tw-color-gray-700);
  }
}
button:disabled {
  background-color: var(--tw-color-gray-300);
  border-color: var(--tw-color-gray-300);
}
</style>
